import Chip from '@material-ui/core/Chip';
import Icon from '@material-ui/core/Icon';
import color from 'color';
import classNames from 'classnames';
import React from 'react';
import styles from './StyledChip.module.scss';

export class StyledChip extends React.Component<{
    label?: string;
    colour?: string;
    children?: string;
    hasAccent?: boolean;
    hasError?: boolean;
    disabled?: boolean;
    maxLength?: number;
    testId?: string;
    avatar?: React.ReactElement;
    readOnly?: boolean;
    tabIndex?: number;
    focused?: boolean;
    onClick?(e: React.MouseEvent<HTMLDivElement>): void;
    onRemove?(e: any): void;
}> {
    public static muiName = 'chip';

    public handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        if (!this.props.disabled && this.props.onClick) this.props.onClick(e);
    };

    public handleRemoveClick = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        if (!this.props.disabled && this.props.onRemove) this.props.onRemove(e);
    };

    public handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
        e.stopPropagation();
        if (!this.props.disabled && this.props.onRemove && e.key === 'Delete') {
            e.preventDefault();
            this.props.onRemove(e);
        }
    };

    public render() {
        const className = classNames(styles.chip, {
            [styles.accented]: this.props.hasAccent,
            [styles.hasError]: this.props.hasError,
            [styles.disabled]: this.props.disabled,
            [styles.focusedChip]: this.props.focused
        });

        const iconClass = classNames(styles.icon, {
            [styles.iconAccented]: this.props.hasAccent,
            [styles.iconHasError]: this.props.hasError,
            [styles.focusedIcon]: this.props.focused
        });

        const iconStyles = {
            backgroundColor: !!this.props.colour
                ? color(this.props.colour).lighten(1).hex()
                : undefined,
            color: !!this.props.colour ? 'white' : undefined
        };

        const chipStyles = {
            backgroundColor: this.props.colour,
            color: !!this.props.colour ? 'white' : undefined
        };

        const initialLabel: string = this.props.label || this.props.children || '';

        const shortLabel =
            this.props.maxLength && initialLabel.length > this.props.maxLength
                ? initialLabel.substring(0, this.props.maxLength) + '...'
                : initialLabel;

        return (
            <Chip
                tabIndex={this.props.tabIndex}
                onClick={this.props.disabled ? undefined : this.props.onClick && this.handleClick}
                onDelete={this.props.disabled ? undefined : this.props.onRemove && this.handleRemoveClick}
                onKeyDown={this.props.disabled ? undefined : this.props.onRemove && this.handleKeyDown}
                data-test-id={this.props.testId}
                deleteIcon={
                    <Icon classes={{ root: iconClass }} style={iconStyles}>
                        close
                    </Icon>
                }
                classes={{
                    root: className
                }}
                icon={!!this.props.avatar ? this.props.avatar : undefined}
                style={chipStyles}
                label={shortLabel}
            />
        );
    }
}
